<template>
  <div id="Cart" dir="rtl">
    <net-pa-list-page-card
      :title="$GetIsAnbohSaz() == 'false' ? 'سبد پرداخت' : 'سبد پرداخت قراردادها'"
      :description="
        $GetIsAnbohSaz() == 'false'
          ? 'اقساط انتخاب‌شده را مدیریت کنید، در صورت نیاز حذف کنید و سپس از طریق درگاه بانکی پرداخت نمایید'
          : 'اقساط انتخاب‌شده را مدیریت کنید و سپس پرداخت را انجام دهید'
      "
      :show-back="true"
    >
      <div v-if="rows.length === 0" class="cart-empty-state">
        <i class="fas fa-shopping-bag cart-empty-state__icon" aria-hidden="true"></i>
        <p class="cart-empty-state__text">سبد پرداخت شما خالی است</p>
        <button type="button" class="btn btn-outline-success" @click="$router.go(-1)">
          بازگشت
        </button>
      </div>

      <template v-else>
        <section class="cart-panel">
          <h6 class="cart-panel__title">
            <i class="fas fa-list ml-2"></i>
            {{ $GetIsAnbohSaz() == "false" ? "لیست اقساط" : "لیست اقساط قرارداد" }}
          </h6>

          <div class="cart-table-wrap table-responsive">
            <vue-bootstrap4-table
              v-if="$store.state.renderComponent"
              :rows="rows"
              :columns="columns"
              :config="config"
              :classes="classes"
            >
              <template slot="sort-asc-icon">
                <i class="fa fa-sort-up"></i>
              </template>
              <template slot="sort-desc-icon">
                <i class="fa fa-sort-down"></i>
              </template>
              <template slot="no-sort-icon">
                <i class="fa fa-sort"></i>
              </template>
              <template slot="empty-results">
                <p class="text-right">اطلاعاتی یافت نشد</p>
              </template>
              <template slot="row" slot-scope="props">
                <span class="cart-table__cell">{{ props.row.vbt_id }}</span>
              </template>
              <template slot="SumGhabelPar" slot-scope="props">
                <span class="cart-table__cell cart-table__amount">
                  {{ $Comma3ragham(props.row.SumGhabelPar) }}
                </span>
              </template>
              <template slot="nameFamily" slot-scope="props">
                <span class="cart-table__cell">
                  {{ props.row.nameFamily != null ? props.row.nameFamily : "خودم" }}
                </span>
              </template>
              <template slot="Action" slot-scope="props">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger cart-remove-btn"
                  @click="Delete(props.row.id)"
                >
                  <i class="fas fa-trash ml-1"></i>
                  حذف
                </button>
              </template>
            </vue-bootstrap4-table>
          </div>

          <div class="cart-actions-bar">
            <button
              type="button"
              class="btn btn-outline-danger cart-clear-all-btn"
              @click="DeleteAllItemsCart()"
            >
              <i class="fas fa-trash ml-2"></i>
              حذف تمامی موارد
            </button>
          </div>
        </section>

        <section class="cart-panel cart-panel--checkout">
          <h6 class="cart-panel__title">
            <i class="fas fa-credit-card ml-2"></i>
            اطلاعات نهایی و انتخاب درگاه
          </h6>

          <div class="cart-checkout-grid">
            <div class="cart-summary-panel">
              <div class="cart-summary-panel__body">
                <p class="cart-summary-panel__hint">
                  پس از اطمینان از مبلغ، درگاه پرداخت را انتخاب کرده و دکمه پرداخت را بزنید.
                </p>
                <div class="cart-summary-panel__label">جمع مبالغ قابل پرداخت</div>
                <div class="cart-summary-panel__amount">
                  {{ $Comma3ragham(GetSumCart()) }}
                  <span class="cart-summary-panel__unit">{{ $GetVahedPool() }}</span>
                </div>
                <div class="cart-summary-panel__persian">{{ Mab2persian }}</div>
              </div>
            </div>

            <div class="cart-payment-panel">
              <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest">
                <template v-slot:ContentButtonPayment>
                  <button
                    type="button"
                    :disabled="GetSumCart() < 10000"
                    class="btn btn-success cart-pay-btn"
                    @click="Payment"
                  >
                    پرداخت {{ $Comma3ragham(GetSumCart()) }}
                  </button>
                </template>
              </payment>
            </div>
          </div>
        </section>
      </template>
    </net-pa-list-page-card>
  </div>
</template>
<script>
import Num2persian from "num2persian";
import NetPaListPageCard from "../Tools/NetPa/NetPaListPageCard.vue";
import Payment from "./Payment.vue";

export default {
  components: { NetPaListPageCard, Payment },
  data() {
    return {
      rows: [],
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "row",
          slot_name: "row",
        },
        {
          label: "دسته بندی",
          name: "Catrgory",
        },
        {
          label: "نوع ",
          name: "desNoe",
        },
        {
          label: "مشخصات",
          name: "nameFamily",
          slot_name: "nameFamily",
        },
        {
          label:
            this.$GetIsAnbohSaz() == "false"
              ? "شماره حساب | تسهیلات"
              : "شماره قرارداد",
          name: "vCode",
        },
        {
          label: "مبلغ قابل پرداخت",
          name: "SumGhabelPar",
          slot_name: "SumGhabelPar",
        },
        {
          label: "عملیات",
          name: "Action",
          slot_name: "Action",
          sort: false,
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: "table table-hover cart-table",
      },
      GatewayCode: null,
      FixVariz: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: "Post",
        Action: "VarizGorohi/SetVarizGorohi",
        Token: this.$session.get("TokenNetPa"),
      },
    };
  },
  methods: {
    GetList() {
      let list = this.$store.state.Netpa_Cart;

      if (list.length == 0) {
        this.rows = [];
      } else {
        this.rows = [];
        for (let index = 0; index < list.length; index++) {
          for (let jndex = 0; jndex < list[index].item.length; jndex++) {
            list[index].item[jndex].Catrgory = list[index].lbl;
            this.rows.push(list[index].item[jndex]);
          }
        }
        this.GetSumCart();
      }
    },
    Delete(id) {
      let list = this.$store.state.Netpa_Cart;
      for (let index = 0; index < list.length; index++) {
        if (list[index].item.length > 0) {
          for (let jndex = 0; jndex < list[index].item.length; jndex++) {
            if (list[index].item[jndex].id == id) {
              if (list[index].item.length > 1) {
                list[index].item.splice(jndex, 1);
                this.GetList();
                return;
              } else {
                list.splice(index, 1);
                if (list.length < 1) {
                  this.$store.state.Netpa_Cart = [];
                  this.$router.go(-1);
                }
                this.GetList();
                return;
              }
            }
          }
        }
      }
    },
    GetSumCart() {
      var Sum = 0;
      for (let index = 0; index < this.rows.length; index++) {
        Sum += Number((this.rows[index].SumGhabelPar + "").replace(/,/g, ""));
      }
      return Sum;
    },
    Get_GatewayCode(val) {
      this.GatewayCode = val;
    },
    FixVarizGhest(val) {
      this.FixVariz = val;
    },
    Payment() {
      if (this.GatewayCode == 0) {
        if (this.$session.get("CustCode") == 801) {
          this.$swal(
            "اختلال در پرداخت با درگاه",
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
            "warning",
          );
        } else {
          this.$mySweetDefaultTost(
            "عدم انتخاب درگاه",
            "درگاهی برای سامانه تنظیم نشده است",
            "warning",
            3000,
          );
        }
      } else {
        const WwwtblVarizGorohiRiz = [];
        for (let index = 0; index < this.rows.length; index++) {
          if (
            this.rows[index].ListTaahodatRiz &&
            this.rows[index].ListTaahodatRiz.length > 0
          ) {
            for (
              let Jndex = 0;
              Jndex < this.rows[index].ListTaahodatRiz.length;
              Jndex++
            ) {
              WwwtblVarizGorohiRiz.push({
                WwwtblTaahodatId: this.rows[index].id,
                Mablagh:
                  this.rows[index].ListTaahodatRiz[Jndex].mablaghGhest +
                  (this.rows[index].ListTaahodatRiz[Jndex].mabJarime -
                    this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh),
                SharhRiz:
                  " پرداخت گروهی (قسط شماره " +
                  this.rows[index].ListTaahodatRiz[Jndex].shomareGhest +
                  ") _ " +
                  this.rows[index].vCode +
                  " ___ " +
                  "مبلغ بخشش: " +
                  this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh +
                  " ___ " +
                  "مبلغ جریمه :" +
                  this.rows[index].ListTaahodatRiz[Jndex].mabJarime,
                WwwtblAzaId: this.rows[index].wwwtblAzaId,
                BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
                BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
                MablaghJarime:
                  this.rows[index].ListTaahodatRiz[Jndex].mabJarime -
                  this.rows[index].ListTaahodatRiz[Jndex].mabBakhshesh,
                TarixGhest: this.rows[index].ListTaahodatRiz[Jndex].tarixGhest,
                IsTaahodatRiz: true,
              });
            }
          } else {
            WwwtblVarizGorohiRiz.push({
              WwwtblTaahodatId: this.rows[index].id,
              Mablagh: this.rows[index].SumGhabelPar,
              SharhRiz: " پرداخت گروهی  " + this.rows[index].vCode,
              WwwtblAzaId: this.rows[index].wwwtblAzaId,
              BnpCashDBtblTaahodatId: this.rows[index].bnpCashDBtblTaahodatId,
              BnpCashDBtblAzaId: this.rows[index].bnpCashDBtblAzaId,
              MablaghJarime: this.rows[index].wwwJarime,
              TarixGhest: this.rows[index].minTarGhestBedehkar,
              IsTaahodatRiz: false,
            });
          }
        }

        this.DataAxios_Variz.ArryfildValue.Mablagh = this.GetSumCart();
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0;
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.Sharh = "پرداخت گروهی";
        this.DataAxios_Variz.ArryfildValue.ZamanInsert =
          this.$store.state.JalaliDate;
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(
          this.$session.get("UserInfoNetPa").custCode,
        );
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538;
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId =
          this.$session.get("UserInfoNetPa").wwwtblAzaId;
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2;
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz =
          WwwtblVarizGorohiRiz;
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === "Success") {
            if (this.GatewayCode == 0) {
              if (this.$session.get("CustCode") == 801) {
                this.$swal(
                  "اختلال در پرداخت با درگاه",
                  "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)",
                  "warning",
                );
              } else {
                this.$mySweetDefaultTost(
                  "عدم انتخاب درگاه",
                  "درگاهی برای سامانه تنظیم نشده است",
                  "warning",
                  3000,
                );
              }
            } else {
              this.$Payment(
                this.GatewayCode + "",
                JSON.stringify(this.GetSumCart()),
                this.$session.get("UserInfoNetPa").ozvName +
                  " " +
                  this.$session.get("UserInfoNetPa").ozvFamily,
                this.$session.get("UserInfoNetPa").email,
                this.$session.get("UserInfoNetPa").mobile,
                WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
                "",
                this.rows[0].vCode,
                "سبد اقساط",
                JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblAzaId),
                this.$session.get("UserInfoNetPa").custCode,
                JSON.stringify(this.$session.get("UserInfoNetPa").wwwtblShobeId),
                result.idRepoMaster,
                this.$session.get("UserInfoNetPa").codeMeli,
                this.$session.get("UserInfoNetPa").ozvName +
                  " " +
                  this.$session.get("UserInfoNetPa").ozvFamily,
                this.$session.get("UserInfoNetPa").mobile,
                this.$session.get("UserInfoNetPa").codeMeli,
              );
            }
          } else {
            this.$mySweetDefaultTost(
              " ",
              " در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید",
              "warning",
              4000,
            );
            this.DeleteAllItemsCart();
          }
        });
      }
    },
    DeleteAllItemsCart() {
      this.$store.state.Netpa_Cart = [];
      this.GetList();
      this.$router.go(-1);
    },
  },
  mounted() {
    this.GetList();
  },
  computed: {
    Mab2persian() {
      var Mab = this.GetSumCart();
      return Num2persian(Mab) + " ریال ";
    },
  },
};
</script>
<style scoped>
.cart-panel {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 1rem 1.1rem 1.1rem;
  box-sizing: border-box;
}

.cart-panel + .cart-panel {
  margin-top: 1.25rem;
}

.cart-panel__title {
  margin: 0 0 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e8ecf1;
  font-size: 15px !important;
  font-weight: 700;
  color: #2a3f54;
}

.cart-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2.5rem 1rem;
  text-align: center;
}

.cart-empty-state__icon {
  font-size: 2.5rem;
  color: #c5cdd8;
}

.cart-empty-state__text {
  margin: 0;
  font-size: 15px !important;
  color: #6c757d;
}

.cart-actions-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.85rem;
}

.cart-clear-all-btn {
  font-weight: 600;
}

.cart-checkout-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 1rem;
  align-items: stretch;
}

.cart-summary-panel {
  background: #f8f9fb;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 1.25rem 1.1rem;
  text-align: center;
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.cart-summary-panel__body {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
  gap: 0.65rem;
}

.cart-summary-panel__hint {
  margin: 0;
  font-size: 13px !important;
  color: #6c757d;
  line-height: 1.6;
  max-width: 280px;
}

.cart-summary-panel__label {
  font-size: 14px !important;
  font-weight: 600;
  color: #495057;
  margin: 0;
}

.cart-summary-panel__amount {
  font-size: 28px !important;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.3;
  border-bottom: 2px dashed #f38905;
  display: inline-block;
  padding-bottom: 0.35rem;
}

.cart-summary-panel__unit {
  font-size: 14px !important;
  font-weight: 600;
  color: #6c757d;
  margin-right: 0.25rem;
}

.cart-summary-panel__persian {
  margin: 0;
  font-size: 13px !important;
  color: #495057;
  line-height: 1.6;
}

.cart-payment-panel {
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 1rem;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

.cart-pay-btn {
  width: 100%;
  max-width: 320px;
  font-weight: 400;
  border-radius: 10px;
  padding: 0.55rem 1rem;
}

.cart-remove-btn {
  white-space: nowrap;
  font-weight: 600;
}

@media (max-width: 767px) {
  .cart-checkout-grid {
    grid-template-columns: 1fr;
  }

  .cart-summary-panel__amount {
    font-size: 24px !important;
  }

  .cart-pay-btn {
    max-width: 100%;
  }
}
</style>
<style>
#Cart .cart-table-wrap {
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  overflow: hidden;
  background: #f8f9fb;
}

#Cart .cart-table {
  margin-bottom: 0;
  font-size: 13px !important;
}

#Cart .cart-table thead th {
  background: #f0f2f5;
  color: #2a3f54;
  font-weight: 700;
  border-color: #e8ecf1;
  white-space: nowrap;
}

#Cart .cart-table tbody td {
  vertical-align: middle;
  color: #2a3f54;
}

#Cart .cart-table__amount {
  font-weight: 700;
  color: #28a745;
}

#Cart .cart-table__cell {
  display: inline-block;
  margin: 0;
}

#Cart .vbt-search-wrapper {
  padding: 0.75rem;
  background: #f8f9fb;
  border-bottom: 1px solid #e8ecf1;
}
</style>
